import {useEffect, useState} from "react";
import * as lscache from "lscache";

const REELS_SEEN = "reelsSeen";

export const useReelsSeen = () => {
    const [reelsPresentationActive, setReelsPresentationActive] = useState<boolean>(false);
    const reelsAlreadySeen = lscache.get(REELS_SEEN);

    const activeReelsPresentation = () => {
        if (!reelsAlreadySeen) {
            setReelsPresentationActive(true);
        }
    };

    const closeReelsPresentation = () => {
        setReelsPresentationActive(false);
        lscache.set(REELS_SEEN, true);
    };

    useEffect(() => {
        if (reelsPresentationActive && document) {
            document.body.style.overflow = "hidden";
        }

        if (!reelsPresentationActive && document) {
            document.body.style.overflow = "unset";
        }
    }, [reelsPresentationActive]);

    return {reelsPresentationActive, activeReelsPresentation, reelsAlreadySeen, closeReelsPresentation};
};
import {useEffect, useState} from "react";
import * as lscache from "lscache";

const REELS_SEEN = "reelsSeen";

export const useReelsSeen = () => {
    const [reelsPresentationActive, setReelsPresentationActive] = useState<boolean>(false);
    const reelsAlreadySeen = lscache.get(REELS_SEEN);

    const activeReelsPresentation = () => {
        if (!reelsAlreadySeen) {
            setReelsPresentationActive(true);
        }
    };

    const closeReelsPresentation = () => {
        setReelsPresentationActive(false);
        lscache.set(REELS_SEEN, true);
    };

    useEffect(() => {
        if (reelsPresentationActive && document) {
            document.body.style.overflow = "hidden";
        }

        if (!reelsPresentationActive && document) {
            document.body.style.overflow = "unset";
        }
    }, [reelsPresentationActive]);

    return {reelsPresentationActive, activeReelsPresentation, reelsAlreadySeen, closeReelsPresentation};
};
